import { io } from "socket.io-client";
import config from "./config";

const URL = config.backendUrl;
const socket = io(URL, { autoConnect: false });

export default socket;
